import service from '@/store/services/password-service';

const state = {
    user: null,
    token: null,
    isLoading: false,
    error: null,
    passwordRequirements: null
};

const mutations = {
    SET_USER(state, user) {
        state.user = user;
    },
    SET_TOKEN(state, token) {
        state.token = token;
    },
    SET_LOADING(state, status) {
        state.isLoading = status;
    },
    SET_ERROR(state, error) {
        state.error = error;
    },
    SET_PASSWORD_REQUIREMENTS(state, requirements) {
        state.passwordRequirements = requirements;
    }
};

const actions = {
    async changePassword({ commit }, payload) {
        commit('SET_LOADING', true);
        try {
            const response = await service.changePassword(payload);
            commit('SET_LOADING', false);
            return response;
        } catch (error) {
            commit('SET_LOADING', false);
            commit('SET_ERROR', error.message);
            throw error;
        }
    },
    async resetPassword({ commit }, payload) {
        commit('SET_LOADING', true);
        try {
            const response = await service.resetPassword(payload.id, payload);
            commit('SET_LOADING', false);
            return response;
        } catch (error) {
            commit('SET_LOADING', false);
            commit('SET_ERROR', error.message);
            throw error;
        }
    },
    async noneLoginResetPassword({ commit }, payload) {
        commit('SET_LOADING', true);
        try {
            const response = await service.noneLoginResetPassword(payload.id, payload);
            commit('SET_LOADING', false);
            return response;
        } catch (error) {
            commit('SET_LOADING', false);
            commit('SET_ERROR', error.message);
            throw error;
        }
    },

    async forceChangePassword({ commit }, payload) {
        commit('SET_LOADING', true);
        try {
            const response = await service.forceChangePassword(payload.id, payload);
            commit('SET_LOADING', false);
            return response;
        } catch (error) {
            commit('SET_LOADING', false);
            commit('SET_ERROR', error.message);
            throw error;
        }
    },

    async checkPasswordStrength({ commit }, payload) {
        try {
            const response = await service.checkPasswordStrength(payload);
            return response;
        } catch (error) {
            commit('SET_ERROR', error.message);
            throw error;
        }
    },

    async getPasswordRequirements({ commit }) {
        try {
            const response = await service.getPasswordRequirements();
            commit('SET_PASSWORD_REQUIREMENTS', response.data);
            return response;
        } catch (error) {
            commit('SET_ERROR', error.message);
            throw error;
        }
    }
};

const getters = {
    user: state => state.user,
    token: state => state.token,
    isLoading: state => state.isLoading,
    error: state => state.error,
    passwordRequirements: state => state.passwordRequirements
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};